import {cart} from '@/app/js/cart'
import {handleProductCartQuantity} from '@/app/js/product/products'
import {listenOutsideClick} from '@/app/js/helpers/listenOutsideClick'

function openCartPanel(element) {
  element.classList.add('active')
}

function closeCartPanel(element) {
  element.classList.remove('active')
}

function initCartPopupProducts(cartPopupElement) {
  const cartPopupEl = document.querySelector('.js-cart-popup')

  listenOutsideClick(cartPopupEl).promise.then(() => {
    closeCartPanel(cartPopupElement)
  })

  cartPopupEl
    .querySelector('.js-cart-popup-close')
    .addEventListener('click', () => {
      closeCartPanel(cartPopupElement)
    })

  cartPopupEl
    .querySelectorAll('.js-product')
    .forEach(productEl => {
      const {cartId} = productEl.dataset

      productEl
        .querySelector('.js-product-delete')
        .addEventListener('click', () => {
          cart.delete(cartId)
            .then(() => {
              productEl.remove()

              if (cartPopupEl.querySelectorAll('.js-product').length === 0) {
                closeCartPanel(cartPopupElement)
              }
            })
        })

      handleProductCartQuantity(productEl, false)
    })
}

function initCartPanel(html) {
  const cartPanelElement = document.querySelector('.js-cart-panel')
  if (!cartPanelElement) {
    return
  }
  cartPanelElement.innerHTML = html
  openCartPanel(cartPanelElement)
  initCartPopupProducts(cartPanelElement)
}

export function openCartPopup(productId) {
  cart.fetchCart('html', {product_id: productId})
    .then(response => {
      initCartPanel(response.data)
    })
}
